import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatErr } from "../../lib/api";

const STATUSES = ["placed","confirmed","packed","shipped","delivered","cancelled"];

export default function AdmOrders() {
  const [orders, setOrders] = useState([]);
  const [active, setActive] = useState(null);
  const refresh = () => api.get("/orders").then(r=>setOrders(r.data));
  useEffect(()=>{ refresh(); }, []);
  const update = async () => {
    try { await api.put(`/orders/${active.id}`, { status: active.status, tracking_number: active.tracking_number, notes: active.notes }); toast.success("Updated"); setActive(null); refresh(); }
    catch (e) { toast.error(formatErr(e)); }
  };
  return (
    <div className="space-y-6">
      <div><div className="overline mb-2">Operations</div><h1 className="font-display text-4xl text-white">Orders</h1></div>
      <div className="card-luxe overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-[11px] uppercase tracking-luxe text-white/40">
            <tr className="border-b border-white/5"><th className="text-left p-4">Order</th><th>Customer</th><th>Total</th><th>Payment</th><th>Status</th><th>Date</th><th></th></tr>
          </thead>
          <tbody>
            {orders.map(o => (
              <tr key={o.id} className="border-b border-white/5">
                <td className="p-4 text-white">{o.order_number}</td>
                <td className="text-white/70">{o.customer_name}<div className="text-xs text-white/40">{o.customer_email}</div></td>
                <td className="text-copper">AED {o.total.toLocaleString()}</td>
                <td>
                  <span data-testid={`pay-status-${o.id}`} className={`text-[10px] uppercase tracking-luxe px-2 py-0.5 ${
                    o.payment_status === "paid" ? "bg-green-500/10 text-green-400" :
                    o.payment_status === "failed" ? "bg-red-500/10 text-red-400" :
                    o.payment_status === "cod_pending" ? "bg-blue-500/10 text-blue-300" :
                    "bg-yellow-500/10 text-yellow-400"
                  }`}>{o.payment_status || "—"}</span>
                </td>
                <td><span className="text-xs uppercase tracking-luxe text-white/70">{o.status}</span></td>
                <td className="text-white/50 text-xs">{o.created_at?.slice(0,10)}</td>
                <td className="p-4 text-right"><button onClick={()=>setActive({...o})} className="btn-ghost text-xs uppercase tracking-luxe">Manage →</button></td>
              </tr>
            ))}
            {orders.length === 0 && <tr><td colSpan="7" className="p-8 text-center text-white/40">No orders yet</td></tr>}
          </tbody>
        </table>
      </div>
      {active && (
        <div className="fixed inset-0 z-50 maintenance-blur flex items-center justify-center p-6" onClick={()=>setActive(null)}>
          <div className="bg-[#0A0A0A] border border-white/10 max-w-2xl w-full p-8" onClick={(e)=>e.stopPropagation()}>
            <div className="overline">Order</div>
            <h3 className="font-display text-2xl text-white mb-1">{active.order_number}</h3>
            <div className="text-xs text-white/50 mb-6">{active.customer_name} · {active.customer_email}</div>
            <div className="space-y-3 max-h-48 overflow-y-auto mb-6">
              {active.items.map((i,idx) => <div key={idx} className="flex justify-between text-sm"><span>{i.name} ×{i.quantity}</span><span>AED {i.subtotal.toLocaleString()}</span></div>)}
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div><div className="overline mb-1">Status</div><select className="input-box" value={active.status} onChange={(e)=>setActive({...active, status:e.target.value})}>{STATUSES.map(s => <option key={s} value={s}>{s}</option>)}</select></div>
              <div><div className="overline mb-1">DHL Tracking #</div><input className="input-box" value={active.tracking_number||""} onChange={(e)=>setActive({...active, tracking_number:e.target.value})}/></div>
            </div>
            <div className="mt-3"><div className="overline mb-1">Internal notes</div><textarea rows={2} className="input-box resize-none" value={active.notes||""} onChange={(e)=>setActive({...active, notes:e.target.value})}/></div>
            <div className="flex gap-3 mt-6">
              <button onClick={update} className="btn-primary">Save</button>
              <button onClick={()=>setActive(null)} className="btn-outline">Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
